<template>
  <el-dialog :title="title" :visible.sync="open" width="55%">

    <div>
      <el-divider></el-divider>
      <div>
        <el-tabs v-model="activeName">
          <el-tab-pane :label="$t('operatormgr.基础信息')" name="first"></el-tab-pane>
          <el-tab-pane :label="$t('operatormgr.车辆绑定')" name="second"></el-tab-pane>
        </el-tabs>
      </div>
      <div v-if="activeName == 'first'">
        <span class="page_title">{{ $t("operatormgr.base_info") }}</span>
        <el-form ref="form1" :model="form" :rules="rules" style="margin-top: 12px; margin-bottom: 12px" label-width="180px"
          :size="size">
          <el-row>
            <el-col :span="12">
              <el-form-item prop="OPTNickName" :label="$t('operatormgr.nickName')">
                <el-input v-model="form.OPTNickName" :placeholder="$t('operatormgr.please_nick_name')"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item v-if="!isEdit" prop="OPTPSW" :label="$t('operatormgr.opt_psw')">
                <el-input v-model="form.OPTPSW" type="password" autocomplete="new-password"
                  :placeholder="passwordPlaceHolder"></el-input>
              </el-form-item>
              <el-form-item v-else :label="$t('operatormgr.opt_psw')">
                <el-input v-model="form.OPTPSW" type="password" autocomplete="new-password"
                  :placeholder="passwordPlaceHolder"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item :label="$t('operatormgr.opt_name')">
                <el-input v-model="form.OPTName" :placeholder="$t('operatormgr.please_opt_name')"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item prop="MobileTel" :label="$t('operatormgr.opt_mobile')">
                <el-input v-model="form.MobileTel" :placeholder="$t('operatormgr.please_opt_mobile')"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="Email">
                <el-input v-model="form.EMail" :placeholder="$t('operatormgr.please_opt_email')"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item :label="$t('operatormgr.opt_addr')">
                <el-input v-model="form.Address" :placeholder="$t('operatormgr.please_opt_addr')"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item :label="$t('operatormgr.opt_Memo')">
                <el-input type="textarea" v-model="form.Memo"
                  :placeholder="$t('operatormgr.please_opt_Memo')"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <span class="page_title">{{ $t("operatormgr.opt_Quarters") }}</span>
        <el-form ref="form2" :rules="rules" style="margin-top: 12px; margin-bottom: 12px" label-width="120px"
          :size="size">
          <el-form-item prop="OperatorQuarters" :label="$t('operatormgr.opt_Quarters')">
            <el-select v-model="OperatorQuarters" multiple :placeholder="$t('operatormgr.please_opt_Quarters')"
              style="width: 100%">
              <el-option v-for="item in QuarterList" :key="item.QuerterID" :label="item.QuerterName"
                :value="item.QuerterID"></el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </div>
      <div v-if="activeName == 'second'">
        <!-- <span class="page_title">{{ $t("arealimitset.bindvehicle") }}</span> -->
        <div style="margin-top: 12px">
          <div style="width: 100%;display: flex;align-items: center;padding:  0 8px;">
            <el-select :size="size" style="width: 100%" filterable v-model="VID" :placeholder="$t('public.select')">
              <el-option v-for="item in vehicles.data" v-if="item.treeLevel == 5" :key="item.nodeValue"
                :label="item.name" :value="item.nodeValue">
              </el-option>
            </el-select>
            <el-button style="margin-left: 8px" type="primary" :size="size" @click="addBindVehicle">
              {{ $t("public.bind") }}
            </el-button>
          </div>
          <div style="max-height: 250px; overflow: auto; padding: 8px">
            <el-table :size="size" :data="vehicleData" border style="width: 100%; margin-top: 6px">
              <el-table-column type="index" align="center" width="45" :label="$t('public.index')">
              </el-table-column>
              <el-table-column prop="CarNo" align="center" :label="$t('vehicle.carNo')">
              </el-table-column>
              <el-table-column prop="VehicleID" align="center" :label="$t('public.Operation')" width="260">
                <template slot-scope="scope">
                  <el-row style="margin: 0">
                    <el-button type="warning" size="mini" @click="removeBindVehicle(scope.row)">
                      {{ $t("public.removebind") }}
                    </el-button>
                  </el-row>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </div>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="open = false" :size="size">{{
        $t("public.cancel")
      }}</el-button>
      <el-button type="primary" @click="onSubmit" :size="size">{{
        $t("public.save")
      }}</el-button>
    </span>
  </el-dialog>
</template>
<script>
import { Base64 } from "js-base64";
import { mapState } from "vuex";
import { validatePassword, validateMobile } from "@/utils/validate";
export default {
  data() {
    return {
      activeName: "first",
      open: false,
      form: {
        OPT_ID: 0,
        OPTNickName: "",
        MobileTel: "",
        EMail: "",
        Address: "",
        Memo: "",
        OPTPSW: "", //密码，有修改才有填写
      },
      VID: "",
      QuarterList: [],
      OperatorQuarters: [], //选中的角色
      title: "",
      OPTPSW: "", //密码，有修改才有填写
      passwordPlaceHolder: "",
      vehicleData: [

      ],
      isEdit: false,
      rules: {
        OPTNickName: [{
          required: true,
          message: this.$t('operatormgr.please_ope_name'),
          trigger: 'blur'
        }],
        MobileTel: [{
          required: true,
          message: this.$t('operatormgr.please_opt_mobile'),
          trigger: 'blur'
        }],
        OPTPSW: [{
          required: true,
          message: this.$t('operatormgr.please_opt_psw'),
          trigger: 'blur'
        }],
        OperatorQuarters: [{
          required: true,
          message: this.$t('operatormgr.please_opt_Quarters'),
          trigger: 'blur'
        }],


      }
    };
  },
  computed: {
    ...mapState({
      size: (state) => state.app.size,
      operator: (state) => state.user.operator,
      vehicles: (state) => state.app.vehicles,
    }),
  },
  methods: {
    addBindVehicle() {
      if (this.VID == "") {
        this.$message.warning(this.$t("public.please_select"));
        return;
      }
      //判断是否已绑定
      if (this.vehicleData.find(item => item.VehicleID == this.VID)) {
        this.$message.warning(this.$t("operatormgr.opt_vehicle_bound"));
        return;
      }
      this.vehicleData.push({
        VehicleID: this.VID,
        CarNo: this.vehicles.data.find(item => item.nodeValue == this.VID).name,
      })
      this.VID = "";
    },
    removeBindVehicle(row) {
      this.vehicleData = this.vehicleData.filter(item => item.VehicleID !== row.VehicleID);
    },
    add() {
      this.edit({
        OPT_ID: 0,
        OPTNickName: "",
        MobileTel: "",
        EMail: "",

        Address: "",
        Memo: "",
        OPTPSW: "",
      });
     
      this.isEdit = false;
      this.form.OPT_ID = 0;
      this.title = this.$t("operatormgr.add_opt");
      this.passwordPlaceHolder = this.$t("operatormgr.please_opt_psw");
      this.OperatorQuarters = [];
    },
    edit(row) {
      this.open = true;
      this.isEdit = true;
        this.$nextTick(() => {
     
      })
        //  this.$refs["form1"].resetFields();
        // this.$refs["form2"].resetFields();
      //重置表单
    
      this.form = Object.assign({}, row);//这一行会影响到form的输入
      console.log(this.form);
      this.title = this.$t("operatormgr.edit_opt");
      this.passwordPlaceHolder = this.$t("operatormgr.emtpy_opt_psw");
      this.form.OPTPSW = "";
      if (this.form.Address == "<nil>") {
        this.form.Address = "";
      }
      if (this.form.Memo == "<nil>") {
        this.form.Memo = "";
      }
      this.queryBindQuarterListOfOper();

    },
    queryBindQuarterListOfOper() {
      //查询角色列表
      this.$api
        .queryBindQuarterListOfOper({
          OperatorID: this.form.OPT_ID,
        })
        .then((res) => {
          console.log(res);
          if (res && res.code == 200) {
            this.OperatorQuarters = [];
            res.data.data.forEach((element) => {
              this.OperatorQuarters.push(element.QuerterID);
            });
            this.vehicleData = res.data.vehicles;


          }
        });
    },

    onSubmit() {
      //SubjectCorpID 当前企业ID
      // LockState 是否锁定 锁定 1
      this.form.SubjectCorpID = this.operator.CompanyId;
      this.form.OperatorID = this.operator.OperatorId;
      this.form.CompanyID = this.operator.CompanyId;

      //验证输入内容
      if (!this.form.OPTNickName) {
        this.$message.warning(this.$t("operatormgr.please_nick_name"));
        return;
      }
      if (parseInt(this.operator.IsForeign) == 0) {
        //国内账号有这个需求，
        if (!this.form.MobileTel) {
          this.$message.warning(this.$t("operatormgr.please_opt_mobile"));
          return;
        }
        //手机号格式判断
        if (!validateMobile(this.form.MobileTel)) {
          this.$message.warning(this.$t("operatormgr.mobile_format_error"));
          return;
        }
        //账号判断是否是手机号
        if (!validateMobile(this.form.OPTNickName)) {
          this.$message.warning(this.$t("operatormgr.操作员名称必须为手机号"));
          return;
        }
      }
      var psw="";

      if (this.form.OPT_ID == 0) {
        //密码强度判断 &&
        if (!this.form.OPTPSW) {
          this.$message.warning(this.$t("operatormgr.please_opt_psw"));
          return;
        }
        if (!validatePassword(this.form.OPTPSW)) {
          this.$message.warning(this.$t("changepsw.password_strong"));
          return;
        }
        //密码base64加密
       psw = Base64.encode(this.form.OPTPSW);
      } else {
        if (this.form.OPTPSW) {
          if (!validatePassword(this.form.OPTPSW)) {
            this.$message.warning(this.$t("changepsw.password_strong"));
            return;
          }
          psw = Base64.encode(this.form.OPTPSW);
        }
      }

      if (this.OperatorQuarters.length == 0) {
        this.$message.warning(this.$t("operatormgr.please_opt_Quarters"));

        return;
      }
      // this.form.LockState =
      this.form.OperatorQuarters = this.OperatorQuarters.join(",");

      this.form.OperatorBindVehicles = this.vehicleData
        ? this.vehicleData.map(element => element.VehicleID).join(',')
        : '';


      console.log(this.form);

      // this.open = false;
      this.form.OPTPSW = psw;

      this.$api.newOpertatorInfo(this.form).then((res) => {
        if (res.code === 200) {
          this.$message.success(
            this.form.OPT_ID > 0
              ? this.$t("public.edit_success")
              : this.$t("public.add_success")
          );
          this.open = false;
          this.$emit("ok");
        } else {
          this.$message.error(res.message);
        }
      });
    },
    init() {
      //初始化一些参数
      this.queryQuarterList();
    },
    queryQuarterList() {
      //查询角色列表
      this.$api
        .queryQuarterListOfOper({
          OperatorID: this.operator.OperatorId,
          CompanyID: this.operator.CompanyId,
        })
        .then((res) => {
          console.log(res);
          if (res && res.code == 200) {
            this.QuarterList = res.data.data;
          }
        });
    },
  },
  mounted() {
    this.init();
  },
};
</script>
<style scoped lang="scss">
.el-row {
  margin-top: 10px;
}
</style>
